<!-- 首页 -->
<template>
  <div id="indexPage">
    <div class="content-wrap">
      <homeBanner></homeBanner>
      <!-- <div class="total-data-box">
        <div class="inner-box">
          <p class="total-data-title">成就每一个教育梦想</p>
          <div class="total-data-box-content">
            <div class="tdbc-box" v-for="(item, index) in dataInfo" :key="'tdbc' + index">
              <p class="tdbc-box-data">{{item.data}}</p>
              <p class="tdbc-box-name">{{item.name}}</p>
            </div>
          </div>
        </div>
      </div> -->
      <coreCapablity></coreCapablity>
      <solution></solution>
      <productionSolution></productionSolution>
      <achievment></achievment>
      <cooperationDemo></cooperationDemo>
    </div>
  </div>
</template>

<script>
import homeBanner from './components/home-banner/home-banner'
import coreCapablity from './components/core-capablity/core-capablity'
import solution from './components/solution/solution'
import productionSolution from './components/product-solution/product-solution'
import achievment from './components/achievment/achievment'
import cooperationDemo from './components/cooperation-demo/cooperation-demo'
export default {
  data () {
    return {
      metaInfo: {
        title: '未来魔法校-官网', // set a title
        meta: [{
          name: 'keyWords',
          content: '好未来旗下未来魔法校，双师合作伙伴招募已开启'
        }]
      },
      dataInfo: [
        {
          data: '4500+',
          name: '合作机构数'
        },
        {
          data: '5000+',
          name: '服务老师数'
        },
        {
          data: '500000+',
          name: '服务学生数'
        }
      ]
    }
  },
  components: {
    homeBanner,
    coreCapablity,
    solution,
    productionSolution,
    achievment,
    cooperationDemo
  }
}
</script>
<style lang="scss">
#indexPage {
  .part-title{
    font-size: vw(48);
    line-height: vw(63);
    font-weight: bold;
  }
  .total-data-box{
    width:1106px;
    height:285px;
    background: #ffffff;;
    box-shadow:0px 5px 56px 0px rgba(0, 0, 0, 0.04);
    border-radius:10px;
    margin: -53px auto 0px;
    padding: 53px 0px;
    position: relative;
    z-index: 1;
    .inner-box{
      width:960px;
      height:179px;
      border:2px solid rgba(251,89,74,0.1);
      margin: 0 auto;
      border-radius: 10px;
      position: relative;
      .total-data-title{
        position: absolute;
        top: -13px;
        left: 50%;
        transform: translateX(-50%);
        font-size:24px;
        font-family:PingFang SC;
        font-weight:400;
        color:$base-font-color;
        line-height:26px;
        padding: 0px 40px;
        background: #ffffff;
      }
      .total-data-box-content{
        display: flex;
        justify-content: space-around;
        align-items: center;
        width: 100%;
        height: 100%;
        .tdbc-box{
          .tdbc-box-data{
            font-size:35px;
            font-family:PingFang SC;
            font-weight:bold;
            color:#FB594A;
            height: 27px;
            line-height: 27px;
          }
          .tdbc-box-name{
            font-size:16px;
            height: 16px;
            line-height: 16px;
            font-family:PingFang SC;
            font-weight:400;
            margin-top: 25px;
          }
        }
      }
    }
  }
}
@include isMobile {
  #indexPage {
    .part-title{
      font-size: rem(42);
      line-height: rem(40);
      font-weight: 800;
    }
  }
}
</style>

<style scoped lang="scss">
#indexPage {
  .content-wrap{
    .part-title{
      font-size: vw(48);
      line-height: vw(63);
      font-weight: bold;
    }
  }
}

@include isMobile {
  #indexPage {
    /*padding-top: 2.5rem;*/
    .content-wrap {
      .myp-5 {
        padding: 0 rem(50);
      }
    }
  }
}
</style>
